import FullCalendar from '@fullcalendar/react';
import React, { useEffect } from 'react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

import {
  CALENDAR_TYPES,
  RESOURCE_TYPES,
} from '../../../../Utils/helper/schedulerHelper';
import {
  getFacilityBookedSlots,
  getFacultyBookingsData,
  getSessionData,
} from '../../../../Utils/apiServices';

export default function ResourceCalendar(props) {
  const { id, name, resourceType, calendarType } = props;

  const [events, setEvents] = React.useState([]);

  //   retrive events/bookings
  useEffect(() => {
    if (!Object.values(RESOURCE_TYPES).includes(resourceType)) {
      // TODO: dispaly error as resourcetype is not valid
      return;
    }
    //Calendar type to be considered
    if (calendarType === CALENDAR_TYPES.SESSIONS) {
      const payload =
        resourceType === RESOURCE_TYPES.FACULTY
          ? { facultyId: id }
          : { facilityId: id };
      getSessionData(payload)
        .then((res) => {
          console.log(res);
          if (res['data']) {
            setEvents(
              res['data'].map((s) => ({
                title: s.activityType,
                start: `${s.startDate}`,
                end: `${s.endDate}`,
              }))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (calendarType === CALENDAR_TYPES.ACADEMIC_PLANNER) {
      try {
      } catch (error) {}
      // call apis by resource type
      if (resourceType === RESOURCE_TYPES.FACULTY) {
        getFacultyBookingsData({ facultyId: id })
          .then((res) => {
            console.log('facultyBooking data: ', res);
            setEvents(
              Object.values(res).map((s) => ({
                title: s.activityType,
                start: `${s.startDate}`,
                end: `${s.endDate}`,
              }))
            );
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (resourceType === RESOURCE_TYPES.FACILITY) {
        getFacilityBookedSlots({ facilityId: id })
          .then((res) => {
            console.log('facilityBooked slots: ', Object.values(res));
            setEvents(
              Object.values(res).map((s) => ({
                title: s.activityType,
                start: `${s.startDate}`,
                end: `${s.endDate}`,
              }))
            );
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }, [id, resourceType]);

  return (
    <div>
      <FullCalendar
        headerToolbar={{
          left: 'prev,date,next today',
          center: 'title',
          right: 'timeGridWeek,dayGridMonth',
        }}
        plugins={[dayGridPlugin, timeGridPlugin]}
        events={events}
      />
    </div>
  );
}
